import { render, staticRenderFns } from "./WorkspaceWelcomeModal.vue?vue&type=template&id=5a447346&scoped=true"
import script from "./WorkspaceWelcomeModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceWelcomeModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceWelcomeModal.vue?vue&type=style&index=0&id=5a447346&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a447346",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a447346')) {
      api.createRecord('5a447346', component.options)
    } else {
      api.reload('5a447346', component.options)
    }
    module.hot.accept("./WorkspaceWelcomeModal.vue?vue&type=template&id=5a447346&scoped=true", function () {
      api.rerender('5a447346', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceWelcomeModal.vue"
export default component.exports